import React from "react";

// What Simmi is doing while a reply is on its way ("Thinking…", "Pulling up the right example…"), instead of
// bare typing dots. The key comes from the reply stream; the words are in TEXT[lang].status.
const SimmiStatus = ({ statusKey, t, dark = false }) => {
  const label = t.status[statusKey] || t.status.thinking;
  return (
    <span className="simmi-status inline-flex items-center gap-2 py-1" role="status" aria-live="polite">
      <span className="relative flex h-2.5 w-2.5">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#06D3DB] opacity-60" />
        <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-[#06D3DB]" />
      </span>
      <span key={label} className={`simmi-status-label text-[12.5px] ${dark ? "text-white/70" : "text-white/65"}`}>
        {label}
      </span>
    </span>
  );
};

export default SimmiStatus;
